import React from "react";
import { ResponsivePie } from "@nivo/pie";
import { linearGradientDef } from "@nivo/core";
import { Box, CircularProgress } from "@material-ui/core";
import { CheckCircle } from "@material-ui/icons";
import PropTypes from "prop-types";

import { useStyles } from "./Graph.styles";

const Graph = ({ data, fills, audience, loading }) => {
  const classes = useStyles();

  const definition = [
    linearGradientDef("gradientAuto", [
      { offset: 0, color: "inherit" },
      { offset: 100, color: "inherit", opacity: 0 },
    ]),
    {
      id: "gradientA",
      type: "linearGradient",
      colors: [
        { offset: 0, color: "#73B241" },
        { offset: 100, color: "#5B8D32" },
      ],
    },
    {
      id: "gradientB",
      type: "linearGradient",
      colors: [
        { offset: 0, color: "#ED8B00" },
        { offset: 100, color: "#FFC87A" },
      ],
    },
    {
      id: "gradientC",
      type: "linearGradient",
      colors: [
        { offset: 0, color: "#787878" },
        { offset: 100, color: "#585858" },
      ],
    },
    {
      id: "gradientD",
      type: "linearGradient",
      colors: [
        { offset: 0, color: "#CD1C48" },
        { offset: 100, color: "#A80E34" },
      ],
    },
  ];

  // const [total, setTotal] = useState(0);

  // useEffect(() => {
  //   const calculateTotal = () => {
  //     let totalValue = data.reduce(function (accumulator, item) {
  //       return accumulator + item.value;
  //     }, 0);
  //     setTotal(totalValue);
  //   };

  //   calculateTotal();
  // }, []);

  const tooltip = (tooltipData) => {
    let percentage = Math.round((tooltipData.datum.value / audience) * 100);
    return (
      <div className={classes.tooltip}>
        <CheckCircle
          className={classes.tooltipIcon}
          style={{ color: tooltipData.datum.color }}
        ></CheckCircle>
        <span className={classes.tooltipLabel}>{tooltipData.datum.label}</span>
        <span className={classes.tooltipVal}>{percentage}%</span>
      </div>
    );
  };

  return (
    <Box mb={12} id="graph">
      {!loading ? (
        <div className={classes.root}>
          <ResponsivePie
            data={data}
            margin={{ top: 15, right: 0, bottom: 15, left: 0 }}
            innerRadius={0.5}
            padAngle={0.7}
            cornerRadius={0}
            activeOuterRadiusOffset={8}
            enableArcLinkLabels={false}
            arcLabelsSkipAngle={30}
            arcLabelsTextColor="#fff"
            defs={definition}
            fill={fills}
            colors={{ datum: "data.color" }}
            tooltip={tooltip}
          />
          <div className={classes.legends}>
            {data.map((item, index) => {
              return (
                <div className={classes.legendItems} key={index}>
                  <div
                    className={classes.legendDots}
                    style={{ backgroundColor: item.color }}
                  ></div>
                  <span className={classes.legendLabel}>{item.label}</span>
                </div>
              );
            })}
          </div>
        </div>
      ) : (
        <CircularProgress color="primary" />
      )}
    </Box>
  );
};

Graph.propTypes = {
  data: PropTypes.array,
  fills: PropTypes.array,
  audience: PropTypes.number,
  loading: PropTypes.bool,
};

export { Graph };
